module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-token-prac-earned u-flex u-flex-jc--center u-border-a1--white-o10"
  }, [_c('div', {
    staticClass: "c-token-prac-earned__text u-relative t-ffamily--simplon t-fweight--bold t-fsize--xs u-uppercase u-color--white"
  }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n        "), _c('div', {
    staticClass: "c-token-prac-earned__text__border u-absolute u-fit-w u-bg--white u-opacity--20"
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-token-prac-earned__number t-ffamily--simplon t-fweight--light u-color--white"
  }, [_vm._v("\n        " + _vm._s(_vm.praxString) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "c-token-prac-earned__logotype-container u-relative u-flex u-flex-ai--center"
  }, [_c('app-icon', {
    staticClass: "u-fill--white u-opacity--60",
    attrs: {
      "name": "icon-logotype--stroked"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7c6d45e"}!./src/scripts/components/app-token-prac-earned/template.html
// module id = 485
// module chunks = 0